import React, { useContext } from "react";
import { AuthContext } from "../../contexts/AuthContext";
import Header from "../../layout/Header/Header";
import { MenuCard, MenuHeader } from "../../MenuCard";

const ITEMS = [
  { label: "Dashboard Ventas",       icon: "fas fa-signal",             color: "#10b981", bg: "#f0fdf4", href: "/DashboardVentas",       desc: "Panel de ventas",           perm: "menu_reportes" },
  { label: "Dashboard Compras",      icon: "fas fa-cart-plus",          color: "#3b82f6", bg: "#eff6ff", href: "/DashboardCompras",      desc: "Panel de compras",          perm: "menu_reportes" },
  { label: "Dashboard CXP",          icon: "fas fa-chart-bar",          color: "#f59e0b", bg: "#fffbeb", href: "/DashboardCXP",          desc: "Cuentas por pagar",         perm: "menu_reportes" },
  { label: "Dashboard Cobranza",     icon: "fas fa-dollar-sign",        color: "#22c55e", bg: "#f0fdf4", href: "/DashboardCobranza",     desc: "Cuentas por cobrar",        perm: "menu_reportes" },
  { label: "Dashboard Inventarios",  icon: "fas fa-tshirt",             color: "#8b5cf6", bg: "#f5f3ff", href: "/DashboardInventarios",  desc: "Panel de inventarios",      perm: "menu_reportes" },
  { label: "Dashboard Tiendas",      icon: "fas fa-store",              color: "#ec4899", bg: "#fdf2f8", href: "/DashboardTiendas",      desc: "Panel POS",                 perm: "menu_reportes" },
  { label: "Dashboard Gastos",       icon: "fas fa-hand-holding-usd",   color: "#f97316", bg: "#fff7ed", href: "/DashboardGastos",       desc: "Panel de gastos",           perm: "menu_reportes" },
  { label: "Balance",                icon: "fas fa-chart-line",         color: "#6366f1", bg: "#eef2ff", href: "/Balance",               desc: "Balance general",           perm: "menu_reportes" },
];

function BotonesDashboards() {
  const { user } = useContext(AuthContext);
  return (
    <>
      <Header />
      <div className="card container">
        <MenuHeader icon="fas fa-chart-bar" color="#6366f1" bg="#eef2ff" title="Dashboards" subtitle="Paneles ejecutivos por área" />
        {user.menu_reportes ? (
          <div className="row">
            {ITEMS.map((r, i) => (
              <MenuCard key={i} {...r} enabled={!!user[r.perm]} />
            ))}
          </div>
        ) : <p style={{ color: "#94a3b8", fontSize: "0.82rem" }}>Sin acceso.</p>}
      </div>
    </>
  );
}

export default BotonesDashboards;
